<div class="d-flex justify-content-center align-items-center not-found margin-top-l" >
    <div>
        <img src="assets/images/no_watchlist_clients.svg" alt="Not Found" class="not-found-image">
        <div class="margin-top-l margin-bottom-l font-size-32">A review for this opportunity does not exist yet</div> 
        <dds-button
        (clicked)="returnToInitiation()"
        >Return to initiation</dds-button>
    </div>
</div>
